import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { tournamentNameService } from '../../services/tournamentNameService';

const TournamentNameForm = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('大会名を入力してください');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      await tournamentNameService.createTournamentName(name.trim());
      navigate('/admin/tournaments/new');
    } catch (error) {
      setError(error.message || '大会名の登録に失敗しました');
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton onClick={() => navigate('/admin/tournaments/new')}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          大会名登録
        </Typography>
      </Box>

      <Paper sx={{ p: 4, mb: 4, backgroundColor: '#ffffff', maxWidth: 600 }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
            新しい大会名を登録します。登録後、トーナメント作成画面に戻ります。
          </Typography>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="大会名"
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={!!error}
              helperText={error || '大会名を入力してください（例：VCT 2025 Masters、RAGE VALORANT 2025）'}
              disabled={submitting}
              placeholder="例：VCT 2025 Masters Tokyo"
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '1.1rem',
                  padding: '12px 14px',
                },
                '& .MuiInputLabel-root': {
                  fontSize: '1rem',
                },
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: 'primary.main',
                  },
                },
              }}
              inputProps={{
                maxLength: 200,
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              type="submit"
              disabled={submitting}
              sx={{
                background: 'linear-gradient(45deg, #3b82f6 30%, #6366f1 90%)',
                boxShadow: '0 3px 5px 2px rgba(59, 130, 246, .3)',
                position: 'relative',
              }}
            >
              {submitting ? (
                <>
                  <CircularProgress
                    size={24}
                    sx={{
                      position: 'absolute',
                      left: '50%',
                      marginLeft: '-12px',
                    }}
                  />
                  送信中...
                </>
              ) : (
                '登録'
              )}
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/admin/tournaments/new')}
              disabled={submitting}
            >
              キャンセル
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default TournamentNameForm;
